import { CardVariant } from '../types';
import { Typography, TypographyType, TypographyColor, TypographyFontWeight } from './typography';
import { Spacing, SpacingSize, SpacingDirection } from './spacing';
import styles from './motivate-banner.module.scss';
import { Card } from '.';

/**
 * Motivation banner
 */
export const MotivateBanner = () => {
  return (
    <Card variant={CardVariant.benefit} className={styles.motivateBanner}>
      <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.rowsSpacing}>
        <Typography type={TypographyType.h5} color={TypographyColor.white} className={styles.title}>
          Х5 Group — выбор в пользу будущего
        </Typography>

        <div className={styles.textBlock}>
          <Typography weight={TypographyFontWeight.medium} color={TypographyColor.white} className={styles.text}>
            Динамичная компания, где сотрудник сам определяет свое будущее и профессиональное развитие.
          </Typography>

          <Typography weight={TypographyFontWeight.medium} color={TypographyColor.white} className={styles.text}>
            Х5 дает возможности расти как в зрелых бизнесах, так и в стартапах.
          </Typography>

          <Typography weight={TypographyFontWeight.medium} color={TypographyColor.white} className={styles.text}>
            Решай амбициозные задачи, достигай вдохновляющих результатов.
          </Typography>

          <Typography weight={TypographyFontWeight.medium} color={TypographyColor.white} className={styles.text}>
            Успешен ты - успешна компания
          </Typography>
        </div>
      </Spacing>
    </Card>
  );
};
